import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/shared/components/data-table';
import type { Supplier } from '../../types';
import type {
  SupplierColumnDef,
  SupplierRenderContext,
} from '../../hooks/useSupplierListTable';

interface SupplierListViewProps {
  sortedSuppliers: Supplier[];
  visibleColumns: SupplierColumnDef[];
  columnFilters: Record<string, string>;
  ctx: SupplierRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading?: boolean;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onSelectSupplier: (s: Supplier) => void;
  onCreateSupplier: () => void;
}

export function SupplierListView({
  sortedSuppliers,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  onSort,
  onSetColumnFilter,
  onSelectSupplier,
  onCreateSupplier,
}: SupplierListViewProps) {
  return (
    <div className="space-y-2">
      <DataTable<Supplier, SupplierRenderContext>
        items={sortedSuppliers}
        columns={visibleColumns}
        ctx={ctx}
        columnFilters={columnFilters}
        sortKey={sortKey}
        sortDirection={sortDirection}
        isLoading={isLoading}
        onSort={onSort}
        onSetColumnFilter={onSetColumnFilter}
        onRowClick={onSelectSupplier}
        emptyState={
          <>
            No suppliers found.{' '}
            <Button variant="link" size="sm" onClick={onCreateSupplier}>
              <Plus className="h-4 w-4 mr-1" />
              Add Supplier
            </Button>
          </>
        }
      />
    </div>
  );
}
